import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import Action from '@components/Action'
import Edit from '@components/Icon/Edit'

class Actions extends Component {
  static propTypes = {
    modalStore: PropTypes.object,
    paymentData: PropTypes.object
  }

  onEditClick = () => {
    const { modalStore, paymentData } = this.props
    modalStore.show({
      type: 'EXPERT_PAYMENT_DETAILS_FORM',
      props: {
        paymentData: paymentData
      }
    })
  }

  render () {
    return (
      <ul className='actions'>
        <Action onClick={this.onEditClick}>
          <li>
            <Edit />
            <span>Edit</span>
          </li>
        </Action>
      </ul>
    )
  }
}

export default inject('modalStore')(observer(Actions))
